import { render, staticRenderFns } from "./clientAverageTicket.vue?vue&type=template&id=16afcd11&scoped=true&"
import script from "./clientAverageTicket.vue?vue&type=script&lang=js&"
export * from "./clientAverageTicket.vue?vue&type=script&lang=js&"
import style0 from "./clientAverageTicket.vue?vue&type=style&index=0&id=16afcd11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afcd11",
  null
  
)

export default component.exports